import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appSetLanguage } from '../../store/actions';

import Lang from '../../components/Lang';

class Clang extends Component {
    constructor(props) {
        super(props);

        this.setLanguage = this.setLanguage.bind(this);
    }

    setLanguage(lang){
        this.props.appSetLanguage(lang);
    }

    render() {
        return (
            <div>
                <Lang setLanguage={this.setLanguage}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.app.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appSetLanguage: (lang) => dispatch(appSetLanguage(lang))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clang);



// WEBPACK FOOTER //
// ./src/containers/Clang/index.js